import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Stack,
  Link,
  Button,
  Menu,
  MenuItem,
  Container,
  Box,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import "./Header.css";
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';


const navData = [
  { name: "Our Story", id: "ourStory", link: "/our-story" },
  {
    name: "Capabilities",
    id: "capabilities",
    subMenu: true,
    subMenuItems: [
      { name: "Software Development", id: "softwareDevelopment", link: "/software-development" },
      { name: "Cloud Services", id: "cloudServices", link: "/cloud-services" },
      { name: "Product Engineering", id: "productEngineering", link: "/product-engineering" },
      // { name: "Video Engineering", id: "VideoEngineering", link: "/video-engineering" },
      { name: "SRE", id: "SRE", link: "/sre" },
    ]
  },
  {
    name: "Industries",
    id: "industries",
    subMenu: true,
    subMenuItems: [
      { name: "Banking & Finance Services", id: "banking", link: "/banking" },
      { name: "Capital Markets", id: "capitalMarkets", link: "/capital-Markets" },
      { name: "Communications, Media, and Information Services", id: "communications", link: "/communications" },
      { name: "Education", id: "education", link: "/education" },
      { name: "Energy, Resources, and Utilities", id: "energy", link: "/energy" },
      { name: "Healthcare", id: "Healthcare", link: "/healthcare" },
      { name: "Retail", id: "Retail", link: "/retail" },
      { name: "Travel and Logistics", id: "Travel", link: "/travel-logistics" },
      { name: "Automative & Aerospace and Defense", id: "Defense", link: "/defense" }
    ]
  },
  { name: "JAASC", id: "jassacLife", link: "/jassacLife" },
  { name: "Careers", id: "careers", link: "/careers" },
  // {
  //   name: "Insights",
  //   id: "Insights",
  //   subMenu: true,
  //   subMenuItems: [
  //     { name: "Customer Stories", id: "customerStories", link: "/customerStories" },
  //     { name: "Perspectives", id: "perspectives", link: "/perspectives" }
  //   ]
  // }, 
];

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [subMenuId, setSubMenuId] = useState(null);
  const [selectedSubItem, setSelectedSubItem] = useState(null); 

  useEffect(()=>{
    setSelectedSubItem(localStorage.getItem("currentPage") || null);
  },[])
  const openMenu = (event, id) => {
    setAnchorEl(event.currentTarget);
    setOpenMenuId(id);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setOpenMenuId(null);
  };

  const handleSubMenuItemClick = (menuId, item) => {
    localStorage.setItem("currentPage", item);
    setSelectedSubItem(item); // Update selected submenu item
    closeMenu(); // Collapse the menu
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const drawerSubMenu = (id, event) => {
    if (id === subMenuId) {
      setSubMenuId(null);
    }
    else {
      setSubMenuId(id);
    }
  }

  const handleMenuClicked = (id, event) =>{
    openMenu(event, id);
  }

  return (
    <>
      <AppBar position="static" sx={{ bgcolor: "#282c34" }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Link
              href="/"
              className="appLogo"
              sx={{ display: { xs: 'none', md: 'flex' }}}
              onClick={()=> handleSubMenuItemClick("", "")}
            >
              <Typography variant="h6">
                 <img src="images/logo.png" alt="logo" id="logo" />
              </Typography>
            </Link>

            {/* Menu on responsiv start*/}
            <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{ 
                  display: { xs: 'block', md: 'none' },
                 "& .MuiList-root": {
                      bgcolor: "#282c34",
                      color: "white"
                    },
                    "& .MuiPopover-paper": {
                      top: "60px !important",
                      left: "0 !important",
                      width: "100%",
                      maxWidth: "100%"
                    }
                }}
              >
                {navData.map((item) => {
                  if (item.subMenu) {
                    return (
                      <>
                        <MenuItem
                          key={item.id}
                          onClick={(event) => drawerSubMenu(item.id, event)}
                        >
                          {item.name} {subMenuId === item.id ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                        </MenuItem>
                        <div style={{ marginLeft: "50px", display: subMenuId === item.id ? "block" : "none" }}>
                          {item.subMenuItems.map((subItem, index) => (
                            <MenuItem
                              key={`${subItem.id}_${index}`}
                              onClick={() => handleSubMenuItemClick(item.id, subItem.id)}
                            >
                              <Link 
                                key={subItem.id} 
                                href={subItem.link} 
                                className="drawerNavLink" 
                                sx={{ color: selectedSubItem === subItem.id ? "#2de2bf !important" : "black",}}
                              >
                                {subItem.name}
                              </Link>
                            </MenuItem>
                          ))}
                        </div>
                      </>
                    )
                  }
                  return (
                    <MenuItem 
                      key={item.name}
                      onClick={() => handleSubMenuItemClick(item.id, item.id)}
                    >
                      <Link 
                        key={item.id} 
                        href={item.link} 
                        className="drawerNavLink"
                        sx={{ color: selectedSubItem === item.id ? "#2de2bf !important" : "black"}}
                      >
                        {item.name}
                      </Link>
                    </MenuItem>
                  )
                })}
              </Menu>
            </Box>
            {/* Menu on responsiv end*/}

            <Link
              href="/"
              className="appLogo"
              onClick={()=> handleSubMenuItemClick("", "")}
              sx={{ display: { xs: 'flex', md: 'none' }, flexGrow: 1}}
            >
              <Typography variant="h6">
                <img src="images/logo.png" alt="logo" id="logo" />
              </Typography>
            </Link>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              flex={1}
              gap={3}
              sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}
            >
              {navData.map((item) => {
                if (item.subMenu) {
                  return(
                    <>
                    <span 
                      onClick={(event) => handleMenuClicked(item.id, event)}
                      className="navLintBtn"
                      style={{color: openMenuId === item.id ? "#2de2bf" : "white"}}  
                    > 
                      {item.name} {openMenuId === item.id ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </span>
                    <Menu
                        anchorEl={anchorEl}
                        open={openMenuId === item.id}
                        onClose={closeMenu}
                        className="navbarMenu"
                        sx={{
                          "& .MuiList-root": {
                            bgcolor: "#282c34",
                            color: "white"
                          },
                          "& .MuiPopover-paper": {
                            top: "60px !important"
                          }
                        }}
                      >
                        {item.subMenuItems.map((subItem, index) => (
                          <MenuItem
                            key={`${subItem.id}_${index}`}
                            onClick={() => handleSubMenuItemClick(item.id, subItem.id)}
                          >
                            <Link
                              key={subItem.id} 
                              href={subItem.link} 
                              className="drawerNavLink"
                              sx={{ color: selectedSubItem === subItem.id ? "#2de2bf !important" : "black",}} 
                            >
                                {subItem.name}
                            </Link>
                          </MenuItem>
                        ))}
                      </Menu>
                    </>
                  )
                }

                return (
                  <MenuItem
                    key={`${item.id}}`}
                    onClick={() => handleSubMenuItemClick(item.id, item.id)}
                  >
                    <Link
                      sx={{ color: selectedSubItem === item.id ? "#2de2bf !important" : "black"}}
                      key={item.id} 
                      href={item.link} 
                      className="navLink" 
                    >
                      {item.name}
                    </Link>
                  </MenuItem>
                );
              })}

            </Stack>
            <Button href="/contact" onClick={()=> handleSubMenuItemClick("", "")} className="contactUsBtn">
              Contact Us
            </Button>
          </Toolbar>
        </Container>
      </AppBar>

    </>

  );
};

export default Header;